import { h, Component } from 'preact';
import { BaseAnnotation } from '../base_annotation';
import { Panel } from 'rendering/components';
import { PLAYER_CONTROL_EVENT, APPLICATION_EVENT } from 'constants/events';
import { secondsToTimecode } from 'utilities/formatting';
import { accessible, focusable } from 'utilities/accessibility';
import { COMPOSITION_TYPES, getCompositionInfo } from 'constants/annotations';


export class BranchSelector extends BaseAnnotation {
    constructor(props) {
        super(props);
        this.applyGate();
    }

    selectBookmark(bookmark) {
        this.releaseGate();
        this.eventBus.emit(PLAYER_CONTROL_EVENT.CURRENT_TIME, bookmark.start);
    }

    render() {
        const panelStyles = {
            ...this.getElementStyles(),
            display: 'flex'
        };

        return (
            <Panel grid="true" { ...this.dataAttrs } aria-label="Branching Selector" role="dialog" aria-labelledby="branching-prompt" style={ panelStyles }>
                { 
                    this.bookmarks.map((b, i) => {
                        return (
                            <BranchThumbnail
                                key={ `branch-thumb-${i}` }
                                onClick={ this.selectBookmark.bind(this, b) }
                                style={ this.getElementStyles(COMPOSITION_TYPES.BRANCH_SELECTOR.IMAGE) }
                                { ...b } />
                        );
                    })
                }
                <h1 id="branching-prompt" className="prompt" style={ this.getElementStyles(COMPOSITION_TYPES.BRANCH_SELECTOR.CONTENT) }>{ this.props.content || '' }</h1>
            </Panel>
        )
    }

    static get composition() {
        return getCompositionInfo('BRANCH_SELECTOR');

    }

    componentWillUnmount(...args) {
        super.componentWillUnmount(...args);
        this.releaseGate();
    }

    static get schemaType() {
        return 'branchselector';
    }
}

export class BranchThumbnail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        };
    }

    onLoad = e => {
        this.setState({
            loaded: true
        });
    }

    componentDidMount() {
        if (!this.state.loaded && this.imgLoader.complete) {
            this.onLoad();
        }
    }

    componentDidUpdate() {
        if (!this.state.loaded && this.imgLoader.complete) {
            this.onLoad();
        }
    }

    render() {
        return (
            <div className="grid-item" data-loaded={ String(this.state.loaded) } onClick={ this.props.onClick } style={ this.props.style } { ...accessible(this.props.onClick) }>
                <img ref={ ref => this.imgLoader = ref } style={ { opacity: 0, position: 'absolute' } } src={ this.props.thumbnail } onLoad={ this.onLoad } />
                <figure className="figure">
                    <div role="img" aria-label={ this.props.content } className="thumbnail" style={ { backgroundImage: `url(${this.props.thumbnail})` } } />
                    <figcaption>{ `${this.props.content} – ${secondsToTimecode(this.props.start)}` }</figcaption>
                </figure>
            </div>
        )
    }
}